import { graphql } from 'react-relay';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';
import {
	type fetchNativeCollabAGGUsersQuery as UsersQuery$data,
	type fetchNativeCollabAGGUsersQueryVariables as UsersQuery$variables,
} from './__types__/FetchNativeCollabAGGUsersQuery.ts';

export const fetchNativeCollabAGGUsers = (
	accountIds: string[],
): Promise<
	{
		avatar: string;
		email: string;
		id: string;
		name: string;
		userId: string;
	}[]
> => {
	return queryInterop<UsersQuery$data, UsersQuery$variables>({
		query: graphql`
			query fetchNativeCollabAGGUsersQuery($accountIds: [ID!]!) {
				users(accountIds: $accountIds) {
					accountId
					name
					picture
					id
				}
			}
		`,
		interopApolloAggClient: true,
		variables: { accountIds },
	}).then(({ data }) => {
		return (
			data?.users
				?.filter((user) => user?.accountId)
				.map((user) => ({
					avatar: user.picture ?? '',
					email: '',
					id: user.id,
					name: user.name ?? '',
					userId: user.accountId,
				})) ?? []
		);
	});
};
